import { render, staticRenderFns } from "./SBSubTitle.html?vue&type=template&id=1dd8d0b2&scoped=true&"
import script from "./SBSubTitle.ts?vue&type=script&lang=ts&"
export * from "./SBSubTitle.ts?vue&type=script&lang=ts&"
import style0 from "./SBSubTitle.css?vue&type=style&index=0&id=1dd8d0b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8d0b2",
  null
  
)

export default component.exports